import { StaticGetEndpoints } from '../../../types/api/endpoints/staticEndpoints';
import {
  StatsByDayRequestData,
  StatsByMonthRequestData,
  StatsByWeekRequestData,
} from '../../../types/api/endpoints/stats/results.types';
import { api } from '../api';

export const STATS_ENDPOINTS = Object.freeze({
  dashboardCOMWidget: () => api.get(StaticGetEndpoints.DashboardCOMWidget),
  allStatsSpecifiedCOM: (commercialId: number) => api.get(`/stats/dashboard/COM/${commercialId}`),
  allStatsCOM: () => api.get(StaticGetEndpoints.AllStatsCOM),

  dashboardDIRWidget: () => api.get(StaticGetEndpoints.DashboardDIRWidget),
  allStatsDIR: () => api.get(StaticGetEndpoints.AllStatsDIR),

  statsByDay: ({ day, order }: StatsByDayRequestData) => api.get(`/stats/DIR/day/${day}`, { order }),
  statsByWeek: ({ from, to, order }: StatsByWeekRequestData) => api.get(`/stats/DIR/week/${from}/${to}`, { order }),
  statsByMonth: ({ date, order }: StatsByMonthRequestData) => api.get(`/stats/DIR/month/${date}`, { order }),

  dashboardPUBLastMonths: () => api.get(StaticGetEndpoints.DashboardPUBLastMonths),
  dashboardENTLastMonths: () => api.get(StaticGetEndpoints.DashboardENTLastMonths),
});
